module.exports = __webpack_public_path__ + "static/media/Ravani.45a81935.jpg";